// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/business-sustainability/business-sustainability.component.scss
// module id = 1128
// module chunks = 0